<template>
  <b-row class="m-0">
    <b-col lg="6" md="12" v-if="period_context_loaded" class="px-2 pb-4">
      <b-container fluid class="white-box">
        <highcharts :options="chartOptionsLeft"></highcharts>
        <no-data v-if="pie_data_profiles_gender.length < 1"/>
      </b-container>
    </b-col>
    <b-col v-else lg="6" md="12" class="px-2 pb-4">
      <loader-box height="408px"/>
    </b-col>

    <b-col lg="6" md="12" v-if="period_context_loaded" class="px-2 pb-4">
      <b-container v-if="!is_marketplace" fluid class="white-box">
        <highcharts :options="chartOptionsRight"></highcharts>
        <no-data v-if="pie_data_profiles_age.length < 1"/>
      </b-container>
    </b-col>
    <b-col v-else lg="6" md="12" class="px-2 pb-4">
      <loader-box height="408px"/>
    </b-col>
  </b-row>
</template>

<script>
import Highcharts from 'highcharts'
import VueHighcharts from 'highcharts-vue'

import LoaderBox from '@/components/LoaderBox.vue'
import NoData from '@/components/NoData.vue'

export default {
  components: {
    LoaderBox,
    NoData,
  },
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    is_marketplace() { return this.$store.getters.is_marketplace },
    pie_data_profiles_gender() { return this.$store.getters.pie_data_profiles_gender },
    pie_data_profiles_age() { return this.$store.getters.pie_data_profiles_age },
    chartOptionsLeft() {
      const DATA = this.pie_data_profiles_gender;
      const drilldownSeries = this.$store.getters.profile_drilldown_series;

      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: 'Perfil gênero'
        },
        subtitle: {
          text: 'clique para ver detalhes'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        plotOptions: {
          pie: {
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                color: 'white',
                textOutline: 'none'
              },
              formatter: function() {
                return Highcharts.numberFormat(this.percentage, 0) + '%'
              }
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Gênero',
          colorByPoint: true,
          data: DATA,
        }],
        drilldown: {
          series: drilldownSeries
        }
      }
    },
    chartOptionsRight() {
      const DATA = this.pie_data_profiles_age;
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: 'Perfil idade'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                color: 'white',
                textOutline: 'none'
              },
              formatter: function() {
                return Highcharts.numberFormat(this.percentage, 0) + '%'
              }
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Vendas',
          colorByPoint: true,
          data: DATA
        }],
      }
    }
  }
}
</script>

<style>

</style>